import { fetchApi } from '@/config/axiosSetting';
import {
  ExpertEntryTabsQueryResponseType,
  ExpertEntryTabsTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getExpertTabsQuery.type';

export const getExpertTabsQueryFunction = (
  params: ExpertEntryTabsTypeParams,
): Promise<ExpertEntryTabsQueryResponseType[]> => {
  return fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/adjusting/entry_tabs/`,
    {
      params: {
        id: params.id,
        damaged_id: params.damaged_id,
      },
    },
  );
};
